export default "__VITE_ASSET__ae4d211f__"